import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import JobsDashboard from "./dashboard/JobsDashboard";
import LOGO from './SAMware-csLogo22.png'
const C = {
  bg0: "#020913",
  bg1: "#040f1e",
  bg2: "#061529",
  bg3: "#081c35",
  blue: "#00a2ff",
  blueDark: "#0062cc",
  blueGlow: "rgba(0,162,255,0.15)",
  accent: "#00d4ff",
  text: "#e2edf7",
  muted: "#7a9ab5",
  border: "rgba(0,162,255,0.14)",
  cardBg: "rgba(6,21,41,0.85)",
};

const Icon = ({ name, size = 22, color = C.blue }) => {
  const icons = {
    server: <path d="M2 6a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm14 1a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zM2 14a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4zm14 1a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2z"/>,
    cloud: <path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/>,
    shield: <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z"/>,
    network: <><circle cx="12" cy="5" r="2"/><circle cx="5" cy="19" r="2"/><circle cx="19" cy="19" r="2"/><path d="M12 7v3M5 17L12 10M19 17L12 10"/></>,
    serverStack: <><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></>,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></>,
    cpu: <><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 2v2M15 2v2M9 20v2M15 20v2M2 9h2M2 15h2M20 9h2M20 15h2"/></>,
    databaseAlt: <><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></>,
    cog: <><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M19.07 19.07l-1.41-1.41M4.93 19.07l1.41-1.41M12 2v2M12 20v2M2 12h2M20 12h2"/></>,
    check: <polyline points="20 6 9 17 4 12"/>,
    mail: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
    phone: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 012 1.22 2 2 0 013.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>,
    location: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></>,
    globe: <><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></>,
    users: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
    zap: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>,
    clock: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    star: <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>,
    arrow: <><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {icons[name]}
    </svg>
  );
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

function useCounter(target, duration = 1800) {
  const [val, setVal] = useState(0);
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const start = performance.now();
    const tick = now => {
      const p = Math.min((now - start) / duration, 1);
      setVal(Math.round(p * p * target));
      if (p < 1) requestAnimationFrame(tick);
    };
    setTimeout(() => requestAnimationFrame(tick), 400);
  }, [target, duration]);
  return val;
}

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const location = useLocation();
  const companyRef = useRef(null);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const fn = (e) => {
      if (companyRef.current && !companyRef.current.contains(e.target)) {
        setCompanyOpen(false);
      }
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  const NAV = [
    { label: "Home", href: "/" },
  ];

  const SOLUTIONS_LINKS = [
    { label: "Solutions", href: "/solutions", desc: "Infrastructure & cloud solutions" },
    { label: "Services", href: "/services", desc: "Our service methodology" },
    { label: "Support", href: "/support", desc: "Support packages & SLAs" },
  ];

  const PRODUCTS_LINKS = [
    { label: "Servers", href: "/products/servers", desc: "Enterprise server solutions" },
    { label: "PCs & Workstations", href: "/products/pcs", desc: "Business PCs & workstations" },
    { label: "Networking", href: "/products/networking", desc: "Switches, routers & more" },
    { label: "Storage", href: "/products/storage", desc: "Enterprise storage systems" },
  ];

  const COMPANY_LINKS = [
    { label: "About", href: "/about", desc: "Our story & values" },
    { label: "Partners", href: "/partners", desc: "Strategic partnerships" },
    { label: "References", href: "/references", desc: "Our client portfolio" },
    { label: "Job Portal", href: "/jobs", desc: "Join our team" },
  ];

  const isCompanyActive = ["/about", "/partners", "/references", "/jobs"].includes(location.pathname);
  const isSolutionsActive = ["/solutions", "/services", "/support"].includes(location.pathname);
  const isProductsActive = location.pathname.startsWith("/products");
  const [productsOpen, setProductsOpen] = useState(false);
  const productsRef = useRef(null);

  useEffect(() => {
    const fn = (e) => {
      if (productsRef.current && !productsRef.current.contains(e.target)) {
        setProductsOpen(false);
      }
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);
  const [whatWeDoOpen, setWhatWeDoOpen] = useState(false);
  const whatWeDoRef = useRef(null);

  useEffect(() => {
    const fn = (e) => {
      if (whatWeDoRef.current && !whatWeDoRef.current.contains(e.target)) {
        setWhatWeDoOpen(false);
      }
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  return (
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
      background: scrolled ? "rgba(2,9,19,0.96)" : "rgba(2,9,19,0.85)",
      backdropFilter: "blur(20px)",
      borderBottom: `1px solid ${C.border}`,
      transition: "all 0.3s ease",
    }}>
      <div style={{
        maxWidth: 1300, margin: "0 auto", padding: "0 32px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        height: 80,
      }}>
        <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
          <img src={LOGO} alt="SAMware-cs" style={{ height: 70, width: "auto" }} />
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: 32 }} className="sw-desktop-nav">
          {NAV.map(l => (
            <Link key={l.label} to={l.href}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              style={{
              color: location.pathname === l.href ? C.blue : C.muted,
              fontSize: 13.5, fontWeight: 500,
              textDecoration: "none", letterSpacing: "0.03em",
              transition: "color 0.2s",
              borderBottom: location.pathname === l.href ? `2px solid ${C.blue}` : "2px solid transparent",
              paddingBottom: 4,
            }}
              onMouseEnter={e => e.currentTarget.style.color = C.blue}
              onMouseLeave={e => e.currentTarget.style.color = location.pathname === l.href ? C.blue : C.muted}
            >{l.label}</Link>
          ))}

          {/* Solutions Dropdown */}
          <div ref={whatWeDoRef} style={{ position: "relative" }}
            onMouseEnter={() => setWhatWeDoOpen(true)}
            onMouseLeave={() => setWhatWeDoOpen(false)}
          >
            <button
              onClick={() => setWhatWeDoOpen(!whatWeDoOpen)}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: isSolutionsActive ? C.blue : C.muted,
                fontSize: 13.5, fontWeight: 500, letterSpacing: "0.03em",
                display: "flex", alignItems: "center", gap: 6,
                borderBottom: isSolutionsActive ? `2px solid ${C.blue}` : "2px solid transparent",
                transition: "color 0.2s", padding: "0 0 4px 0",
              }}
            >
              Solutions
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                style={{ transform: whatWeDoOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>

            {whatWeDoOpen && (
              <div style={{
                position: "absolute", top: "100%", left: "50%",
                transform: "translateX(-50%)",
                paddingTop: 12,
                zIndex: 1000, minWidth: 230,
              }}>
              <div style={{
                background: "rgba(4,15,30,0.98)", border: `1px solid ${C.border}`,
                borderRadius: 12, padding: "8px",
                backdropFilter: "blur(20px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
              }}>
                {SOLUTIONS_LINKS.map(l => (
                  <Link key={l.label} to={l.href}
                    onClick={() => setWhatWeDoOpen(false)}
                    style={{
                      display: "flex", flexDirection: "column", gap: 3,
                      padding: "10px 14px", borderRadius: 8, textDecoration: "none",
                      background: location.pathname === l.href ? "rgba(0,162,255,0.1)" : "transparent",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = "rgba(0,162,255,0.08)"}
                    onMouseLeave={e => e.currentTarget.style.background = location.pathname === l.href ? "rgba(0,162,255,0.1)" : "transparent"}
                  >
                    <span style={{ fontSize: 14, fontWeight: 600, color: location.pathname === l.href ? C.blue : C.text }}>{l.label}</span>
                    <span style={{ fontSize: 12, color: C.muted }}>{l.desc}</span>
                  </Link>
                ))}
              </div>
              </div>
            )}
          </div>

          {/* Products Dropdown */}
          <div ref={productsRef} style={{ position: "relative" }}
            onMouseEnter={() => setProductsOpen(true)}
            onMouseLeave={() => setProductsOpen(false)}
          >
            <button
              onClick={() => setProductsOpen(!productsOpen)}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: isProductsActive ? C.blue : C.muted,
                fontSize: 13.5, fontWeight: 500, letterSpacing: "0.03em",
                display: "flex", alignItems: "center", gap: 6,
                borderBottom: isProductsActive ? `2px solid ${C.blue}` : "2px solid transparent",
                transition: "color 0.2s", padding: "0 0 4px 0",
              }}
            >
              Products
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                style={{ transform: productsOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            {productsOpen && (
              <div style={{
                position: "absolute", top: "100%", left: "50%",
                transform: "translateX(-50%)",
                paddingTop: 12,
                zIndex: 1000, minWidth: 230,
              }}>
              <div style={{
                background: "rgba(4,15,30,0.98)", border: `1px solid ${C.border}`,
                borderRadius: 12, padding: "8px",
                backdropFilter: "blur(20px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
              }}>
                {PRODUCTS_LINKS.map(l => (
                  <Link key={l.label} to={l.href}
                    onClick={() => setProductsOpen(false)}
                    style={{
                      display: "flex", flexDirection: "column", gap: 3,
                      padding: "10px 14px", borderRadius: 8, textDecoration: "none",
                      background: location.pathname === l.href ? "rgba(0,162,255,0.1)" : "transparent",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = "rgba(0,162,255,0.08)"}
                    onMouseLeave={e => e.currentTarget.style.background = location.pathname === l.href ? "rgba(0,162,255,0.1)" : "transparent"}
                  >
                    <span style={{ fontSize: 14, fontWeight: 600, color: location.pathname === l.href ? C.blue : C.text }}>{l.label}</span>
                    <span style={{ fontSize: 12, color: C.muted }}>{l.desc}</span>
                  </Link>
                ))}
              </div>
              </div>
            )}
          </div>

          {/* Company Dropdown */}
          <div ref={companyRef} style={{ position: "relative" }}
            onMouseEnter={() => setCompanyOpen(true)}
            onMouseLeave={() => setCompanyOpen(false)}
          >
            <button
              onClick={() => setCompanyOpen(!companyOpen)}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: isCompanyActive ? C.blue : C.muted,
                fontSize: 13.5, fontWeight: 500, letterSpacing: "0.03em",
                display: "flex", alignItems: "center", gap: 6, paddingBottom: 4,
                borderBottom: isCompanyActive ? `2px solid ${C.blue}` : "2px solid transparent",
                transition: "color 0.2s", padding: "0 0 4px 0",
              }}
            >
              Company
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                style={{ transform: companyOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>

            {companyOpen && (
              <div style={{
                position: "absolute", top: "100%", left: "50%",
                transform: "translateX(-50%)",
                paddingTop: 12,
                zIndex: 1000, minWidth: 220,
              }}>
              <div style={{
                background: "rgba(4,15,30,0.98)", border: `1px solid ${C.border}`,
                borderRadius: 12, padding: "8px",
                backdropFilter: "blur(20px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
              }}>
                {COMPANY_LINKS.map(l => (
                  <Link key={l.label} to={l.href}
                    onClick={() => setCompanyOpen(false)}
                    style={{
                      display: "flex", flexDirection: "column", gap: 3,
                      padding: "10px 14px", borderRadius: 8, textDecoration: "none",
                      background: location.pathname === l.href ? "rgba(0,162,255,0.1)" : "transparent",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = "rgba(0,162,255,0.08)"}
                    onMouseLeave={e => e.currentTarget.style.background = location.pathname === l.href ? "rgba(0,162,255,0.1)" : "transparent"}
                  >
                    <span style={{ fontSize: 14, fontWeight: 600, color: location.pathname === l.href ? C.blue : C.text }}>{l.label}</span>
                    <span style={{ fontSize: 12, color: C.muted }}>{l.desc}</span>
                  </Link>
                ))}
              </div>
              </div>
            )}
          </div>

          <Link to="/contact" style={{
            background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
            color: "#fff", padding: "9px 24px", borderRadius: 7,
            fontSize: 13.5, fontWeight: 600, textDecoration: "none",
          }}>Get in Touch</Link>
        </div>

        <button onClick={() => setOpen(!open)} className="sw-hamburger" style={{
          display: "none", background: "none", border: "none",
          cursor: "pointer", color: C.muted, padding: 8,
        }}>
          {open
            ? <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="8" x2="21" y2="8"/><line x1="3" y1="14" x2="21" y2="14"/></svg>
          }
        </button>
      </div>

      {open && (
        <div style={{
          background: "rgba(2,9,19,0.98)", padding: "16px 32px 24px",
          borderTop: `1px solid ${C.border}`, display: "flex",
          flexDirection: "column", gap: 16,
        }}>
          {NAV.map(l => (
            <Link key={l.label} to={l.href} onClick={() => setOpen(false)} style={{
              color: C.muted, fontSize: 16, textDecoration: "none", fontWeight: 500,
            }}>{l.label}</Link>
          ))}
          <div style={{ fontSize: 12, color: C.blue, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginTop: 8 }}>Solutions</div>
          {SOLUTIONS_LINKS.map(l => (
            <Link key={l.label} to={l.href} onClick={() => setOpen(false)} style={{
              color: C.muted, fontSize: 16, textDecoration: "none", fontWeight: 500, paddingLeft: 12,
            }}>{l.label}</Link>
          ))}
          <div style={{ fontSize: 12, color: C.blue, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginTop: 8 }}>Products</div>
          {PRODUCTS_LINKS.map(l => (
            <Link key={l.label} to={l.href} onClick={() => setOpen(false)} style={{
              color: C.muted, fontSize: 16, textDecoration: "none", fontWeight: 500, paddingLeft: 12,
            }}>{l.label}</Link>
          ))}
          <div style={{ fontSize: 12, color: C.blue, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginTop: 8 }}>Company</div>
          {COMPANY_LINKS.map(l => (
            <Link key={l.label} to={l.href} onClick={() => setOpen(false)} style={{
              color: C.muted, fontSize: 16, textDecoration: "none", fontWeight: 500, paddingLeft: 12,
            }}>{l.label}</Link>
          ))}
          <Link to="/contact" onClick={() => setOpen(false)} style={{
            color: C.muted, fontSize: 16, textDecoration: "none", fontWeight: 500, marginTop: 8,
          }}>Contact</Link>
        </div>
      )}

      <style>{`
        @media(max-width:768px){
          .sw-desktop-nav{display:none!important}
          .sw-hamburger{display:block!important}
        }
      `}</style>
    </nav>
  );
}

function PageWrapper({ children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={{ paddingTop: 80, minHeight: "100vh", background: C.bg0, position: "relative" }}>
      <div style={{
        position: "fixed", inset: 0, opacity: 0.05, pointerEvents: "none", zIndex: 0,
        backgroundImage: `linear-gradient(${C.blue} 1px, transparent 1px), linear-gradient(90deg, ${C.blue} 1px, transparent 1px)`,
        backgroundSize: "60px 60px",
      }}/>
      <div style={{ position: "relative", zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
}

function Section({ id, bg, children, style = {} }) {
  return (
    <section id={id} style={{ background: bg || C.bg1, padding: "80px 32px", ...style }}>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>{children}</div>
    </section>
  );
}

function SectionHeader({ tag, title, sub }) {
  return (
    <div style={{ marginBottom: 60, textAlign: "center" }}>
      {tag && (
        <div style={{
          display: "inline-block", background: "rgba(0,162,255,0.1)",
          border: `1px solid rgba(0,162,255,0.2)`, borderRadius: 100,
          padding: "4px 16px", marginBottom: 16,
          fontSize: 12, fontWeight: 700, color: C.blue, letterSpacing: "0.08em",
        }}>{tag}</div>
      )}
      <h2 style={{
        fontSize: "clamp(1.6rem, 2.5vw, 2.2rem)", fontWeight: 700,
        color: C.text, margin: "0 0 16px",
        fontFamily: "'Syne', 'Segoe UI', sans-serif",
      }}>{title}</h2>
      {sub && <p style={{ color: C.muted, fontSize: 17, maxWidth: 620, margin: "0 auto" }}>{sub}</p>}
    </div>
  );
}

function TechCard({ illustration, label, desc, color, glow }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? `linear-gradient(160deg, ${glow}, rgba(4,15,30,0.95))` : C.cardBg,
        border: `1px solid ${hovered ? color : C.border}`,
        borderRadius: 16, padding: "32px 20px 24px", textAlign: "center",
        transition: "all 0.35s ease", cursor: "pointer",
        transform: hovered ? "translateY(-10px)" : "none",
        boxShadow: hovered ? `0 24px 64px ${glow}` : "none",
      }}
    >
      <div style={{
        width: 88, height: 88, margin: "0 auto 20px",
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "all 0.35s ease",
        filter: hovered ? "none" : "grayscale(0.4) opacity(0.6)",
      }}>
        {illustration(hovered ? color : "#7a9ab5")}
      </div>
      <h3 style={{ fontSize: 14.5, fontWeight: 700, color: hovered ? "#fff" : C.text, marginBottom: 10, transition: "color 0.3s" }}>{label}</h3>
      <p style={{ fontSize: 12.5, color: hovered ? "rgba(226,237,247,0.7)" : C.muted, lineHeight: 1.65, transition: "color 0.3s" }}>{desc}</p>
    </div>
  );
}

const techIllustrations = {
  aiInfra: (c) => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none">
      {/* Brain chip */}
      <rect x="24" y="24" width="40" height="40" rx="8" stroke={c} strokeWidth="2"/>
      <rect x="32" y="32" width="24" height="24" rx="4" stroke={c} strokeWidth="1.5"/>
      <circle cx="44" cy="44" r="6" fill={c} opacity="0.25" stroke={c} strokeWidth="1.5"/>
      {/* Pins left */}
      <line x1="16" y1="34" x2="24" y2="34" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="16" y1="42" x2="24" y2="42" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="16" y1="50" x2="24" y2="50" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      {/* Pins right */}
      <line x1="64" y1="34" x2="72" y2="34" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="64" y1="42" x2="72" y2="42" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="64" y1="50" x2="72" y2="50" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      {/* Pins top */}
      <line x1="34" y1="16" x2="34" y2="24" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="44" y1="16" x2="44" y2="24" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="54" y1="16" x2="54" y2="24" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      {/* Pins bottom */}
      <line x1="34" y1="64" x2="34" y2="72" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="44" y1="64" x2="44" y2="72" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="54" y1="64" x2="54" y2="72" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      {/* Stars */}
      <circle cx="20" cy="20" r="2" fill={c} opacity="0.8"/>
      <circle cx="68" cy="20" r="1.5" fill={c} opacity="0.6"/>
      <circle cx="20" cy="68" r="1.5" fill={c} opacity="0.6"/>
    </svg>
  ),
  dataCenter: (c) => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none">
      {/* Server rack - 3 units */}
      <rect x="18" y="18" width="52" height="14" rx="3" stroke={c} strokeWidth="1.8"/>
      <rect x="18" y="37" width="52" height="14" rx="3" stroke={c} strokeWidth="1.8"/>
      <rect x="18" y="56" width="52" height="14" rx="3" stroke={c} strokeWidth="1.8"/>
      {/* LED dots */}
      <circle cx="28" cy="25" r="2.5" fill={c} opacity="0.9"/>
      <circle cx="35" cy="25" r="2.5" fill={c} opacity="0.5"/>
      <circle cx="28" cy="44" r="2.5" fill={c} opacity="0.7"/>
      <circle cx="35" cy="44" r="2.5" fill={c} opacity="0.9"/>
      <circle cx="28" cy="63" r="2.5" fill={c} opacity="0.5"/>
      <circle cx="35" cy="63" r="2.5" fill={c} opacity="0.8"/>
      {/* Drive slots */}
      <rect x="44" y="22" width="20" height="6" rx="1.5" stroke={c} strokeWidth="1.2" opacity="0.6"/>
      <rect x="44" y="41" width="20" height="6" rx="1.5" stroke={c} strokeWidth="1.2" opacity="0.6"/>
      <rect x="44" y="60" width="20" height="6" rx="1.5" stroke={c} strokeWidth="1.2" opacity="0.6"/>
    </svg>
  ),
  cloud: (c) => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none">
      {/* Main cloud */}
      <path d="M58 56H30a12 12 0 01-2-23.8A16 16 0 0158.5 38 10 10 0 0158 56z" stroke={c} strokeWidth="2" strokeLinejoin="round"/>
      {/* Upload arrow */}
      <line x1="44" y1="68" x2="44" y2="46" stroke={c} strokeWidth="2" strokeLinecap="round"/>
      <polyline points="37,53 44,46 51,53" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Small floating cloud */}
      <path d="M68 34h-8a5 5 0 01-.8-9.9A6.5 6.5 0 0168.2 27 4 4 0 0168 34z" stroke={c} strokeWidth="1.4" opacity="0.6"/>
      {/* Dots */}
      <circle cx="20" cy="42" r="2" fill={c} opacity="0.4"/>
      <circle cx="72" cy="52" r="1.5" fill={c} opacity="0.4"/>
    </svg>
  ),
  security: (c) => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none">
      {/* Shield */}
      <path d="M44 16L22 26v18c0 14 9.8 27 22 31 12.2-4 22-17 22-31V26L44 16z" stroke={c} strokeWidth="2" strokeLinejoin="round"/>
      {/* Check inside */}
      <polyline points="34,44 41,51 54,38" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Glow rings */}
      <path d="M44 10L16 22v22c0 17 12 32 28 37" stroke={c} strokeWidth="1" opacity="0.25" strokeLinejoin="round"/>
    </svg>
  ),
  network: (c) => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none">
      {/* Center hub */}
      <circle cx="44" cy="44" r="8" stroke={c} strokeWidth="2"/>
      <circle cx="44" cy="44" r="3" fill={c} opacity="0.5"/>
      {/* Nodes */}
      <circle cx="20" cy="24" r="5" stroke={c} strokeWidth="1.8"/>
      <circle cx="68" cy="24" r="5" stroke={c} strokeWidth="1.8"/>
      <circle cx="20" cy="64" r="5" stroke={c} strokeWidth="1.8"/>
      <circle cx="68" cy="64" r="5" stroke={c} strokeWidth="1.8"/>
      <circle cx="44" cy="16" r="4" stroke={c} strokeWidth="1.6" opacity="0.7"/>
      <circle cx="44" cy="72" r="4" stroke={c} strokeWidth="1.6" opacity="0.7"/>
      {/* Lines to center */}
      <line x1="25" y1="27" x2="38" y2="38" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="63" y1="27" x2="50" y2="38" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="25" y1="61" x2="38" y2="50" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="63" y1="61" x2="50" y2="50" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="44" y1="20" x2="44" y2="36" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="44" y1="52" x2="44" y2="68" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
};

function HomePage() {
  const yrs = useCounter(5);
  const partners = useCounter(30);
  const clients = useCounter(50);

  // eslint-disable-next-line no-unused-vars
  const services = [
    { icon: "cpu", title: "Digital Transformation", desc: "End-to-end data center modernization and hyper-converged infrastructure solutions." },
    { icon: "cloud", title: "Cloud Services", desc: "Public, private, and hybrid cloud strategy, migration, and management." },
    { icon: "shield", title: "Cybersecurity", desc: "Comprehensive protection for your infrastructure, data, and endpoints." },
    { icon: "network", title: "Network Intelligence", desc: "SD-WAN, monitoring, and intelligent networking solutions." },
  ];
  

  const reasons = [
    { val: "5+", label: "Years of Excellence", desc: "Decades of proven expertise in the regional IT market." },
    { val: "50+", label: "Clients Served", desc: "Trusted by leading organizations across all sectors." },
    { val: "30+", label: "Strategic Partners", desc: "Elite partnerships with global technology leaders." },
    { val: "24/7", label: "Support Available", desc: "Round-the-clock support for mission-critical systems." },
  ];

  const topPartners = ["Dell Technologies","Oracle","VMware","Cisco","HPE","Fortinet","Palo Alto Networks","Nutanix","NetApp","Red Hat","Veeam","Juniper"];

  return (
    <div>
      {/* ── Hero ── */}
      <div style={{
        minHeight: "100vh", position: "relative", overflow: "hidden",
        display: "flex", alignItems: "center",
        background: `radial-gradient(ellipse 80% 70% at 50% -10%, rgba(0,98,204,0.22) 0%, transparent 70%), ${C.bg0}`,
      }}>
        <div style={{ position: "absolute", inset: 0, opacity: 0.07, backgroundImage: `linear-gradient(${C.blue} 1px, transparent 1px), linear-gradient(90deg, ${C.blue} 1px, transparent 1px)`, backgroundSize: "60px 60px" }}/>
        <div style={{ position: "absolute", top: "20%", left: "-5%", width: 600, height: 600, borderRadius: "50%", background: "radial-gradient(circle, rgba(0,98,204,0.12) 0%, transparent 70%)", filter: "blur(40px)" }}/>
        <div style={{ position: "absolute", bottom: "10%", right: "5%", width: 450, height: 450, borderRadius: "50%", background: "radial-gradient(circle, rgba(0,162,255,0.1) 0%, transparent 70%)", filter: "blur(60px)" }}/>
        <div style={{ maxWidth: 1300, margin: "0 auto", padding: "120px 32px 80px", position: "relative", zIndex: 1, width: "100%" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center" }} className="sw-hero-grid">
            <div>
              <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(0,162,255,0.1)", border: `1px solid rgba(0,162,255,0.25)`, borderRadius: 100, padding: "6px 16px", marginBottom: 28 }}>
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: C.blue, animation: "pulse 2s infinite" }}/>
                <span style={{ color: C.blue, fontSize: 13, fontWeight: 600, letterSpacing: "0.06em" }}>YOUR TRUSTED IT PARTNER SINCE 2020</span>
              </div>
              <h1 style={{ fontSize: "clamp(2.8rem, 5vw, 4.2rem)", fontWeight: 600, lineHeight: 0.9, color: C.text, margin: "0 0 24px", fontFamily: "'Syne', 'Segoe UI', sans-serif" }}>
                Empowering Business<br/>
                <span style={{ background: `linear-gradient(135deg, ${C.blue}, ${C.accent})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Through Technology</span>
              </h1>
              <p style={{ fontSize: 18, color: C.muted, lineHeight: 1.75, maxWidth: 560, margin: "0 0 40px" }}>
                SAMware-cs delivers end-to-end IT consultancy, infrastructure solutions, and managed services.
              </p>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                <Link to="/solutions" style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", padding: "14px 32px", borderRadius: 8, fontSize: 15, fontWeight: 600, textDecoration: "none", boxShadow: "0 8px 32px rgba(0,98,204,0.35)", display: "inline-flex", alignItems: "center", gap: 8 }}>
                  Explore Solutions <Icon name="arrow" size={16} color="#fff"/>
                </Link>
                
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }} className="sw-hero-stats">
              <div style={{ position: "relative", borderRadius: 16, overflow: "hidden", height: 200 }}>
                <img src={require('./data-center-infrastructure-oct23-main-1.jpg')} alt="Data Center"
                  style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.65)" }}/>
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(0,98,204,0.4), transparent)" }}/>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div style={{ borderRadius: 12, overflow: "hidden", height: 110 }}>
                  <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=300&q=80" alt="" 
                    style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.65)" }}/>
                </div>
                <div style={{ borderRadius: 12, overflow: "hidden", height: 110 }}>
                  <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?w=300&q=80" alt=""
                    style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.65)" }}/>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
                {[{ val: `${yrs}+`, label: "Years" }, { val: `${partners}+`, label: "Partners" }, { val: `${clients}+`, label: "Clients" }].map(s => (
                  <div key={s.label} style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 10, padding: "14px 10px", textAlign: "center", backdropFilter: "blur(12px)" }}>
                    <div style={{ fontSize: 28, fontWeight: 800, color: C.blue, lineHeight: 1 }}>{s.val}</div>
                    <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <style>{`
          @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
          @media(max-width:900px){ .sw-hero-grid{grid-template-columns:1fr!important} .sw-hero-stats{display:none!important} }
        `}</style>
      </div>



      {/* ── Tech Icons Section ── */}
      <section style={{ background: C.bg0, padding: "90px 32px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <div style={{ display: "inline-block", background: "rgba(0,162,255,0.1)", border: `1px solid rgba(0,162,255,0.2)`, borderRadius: 100, padding: "4px 16px", marginBottom: 16, fontSize: 12, fontWeight: 700, color: C.blue, letterSpacing: "0.08em" }}>CORE TECHNOLOGIES</div>
            <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 600, color: C.text, margin: "0 0 14px", fontFamily: "'Syne', 'Segoe UI', sans-serif" }}>Technologies to Accelerate Innovation</h2>
            <p style={{ color: C.muted, fontSize: 16, maxWidth: 540, margin: "0 auto" }}>End-to-end technology domains that power modern enterprises — from data center to cloud to security.</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 20 }} className="sw-tech-grid">
            {[
              { illustration: techIllustrations.aiInfra, label: "AI Infrastructure", desc: "Intelligent compute and GPU solutions for AI workloads.", color: "#7c3aed", glow: "rgba(124,58,237,0.2)" },
              { illustration: techIllustrations.dataCenter, label: "Data Center", desc: "End-to-end rack, power, and cooling infrastructure.", color: "#e53935", glow: "rgba(229,57,53,0.2)" },
              { illustration: techIllustrations.cloud, label: "Cloud Services", desc: "Hybrid and multi-cloud strategy and migration.", color: "#00a2ff", glow: "rgba(0,162,255,0.2)" },
              { illustration: techIllustrations.security, label: "Cybersecurity", desc: "Zero-trust security for your entire infrastructure.", color: "#059669", glow: "rgba(5,150,105,0.2)" },
              { illustration: techIllustrations.network, label: "Network Intelligence", desc: "SD-WAN, monitoring, and smart networking.", color: "#d97706", glow: "rgba(217,119,6,0.2)" },
            ].map(t => (
              <TechCard key={t.label} {...t}/>
            ))}
          </div>
        </div>
        <style>{`@media(max-width:1100px){.sw-tech-grid{grid-template-columns:repeat(3,1fr)!important}} @media(max-width:600px){.sw-tech-grid{grid-template-columns:repeat(2,1fr)!important}}`}</style>
      </section>

      {/* ── Why Us ── */}
      <section style={{ background: C.bg0, padding: "90px 32px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }} className="sw-why-grid">
            <div>
              <div style={{ display: "inline-block", background: "rgba(0,162,255,0.1)", border: `1px solid rgba(0,162,255,0.2)`, borderRadius: 100, padding: "4px 16px", marginBottom: 16, fontSize: 12, fontWeight: 700, color: C.blue, letterSpacing: "0.08em" }}>WHY SAMWARE-CS</div>
              <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 600, color: C.text, margin: "0 0 20px", fontFamily: "'Syne', 'Segoe UI', sans-serif" }}>Your Technology Partner, Not Just a Vendor</h2>
              <p style={{ color: C.muted, fontSize: 16, lineHeight: 1.8, marginBottom: 32 }}>
                For over 5 years, SAMware-cs has been the trusted bridge between technology and business value — delivering measurable outcomes across Lebanon and the region.
              </p>
              {["End-to-end ownership from design to support", "Certified engineers across all major platforms", "Local presence with global vendor access"].map(pt => (
                <div key={pt} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
                  <div style={{ width: 22, height: 22, borderRadius: "50%", background: "rgba(0,162,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <Icon name="check" size={12} color={C.blue}/>
                  </div>
                  <span style={{ fontSize: 14.5, color: C.muted }}>{pt}</span>
                </div>
              ))}
              <Link to="/about" style={{ marginTop: 16, display: "inline-flex", alignItems: "center", gap: 8, color: C.blue, textDecoration: "none", fontSize: 14, fontWeight: 600 }}>
                Learn More About Us <Icon name="arrow" size={15} color={C.blue}/>
              </Link>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              {reasons.map(r => (
                <div key={r.label} style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 14, padding: "24px 20px", transition: "all 0.3s ease" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-4px)"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; }}>
                  <div style={{ fontSize: 30, fontWeight: 800, color: C.blue, marginBottom: 4 }}>{r.val}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: C.text, marginBottom: 8 }}>{r.label}</div>
                  <div style={{ fontSize: 12, color: C.muted, lineHeight: 1.6 }}>{r.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <style>{`@media(max-width:768px){.sw-why-grid{grid-template-columns:1fr!important}}`}</style>
      </section>

      {/* ── Partners Strip ── */}
      <section style={{ background: C.bg1, padding: "60px 32px", borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <p style={{ fontSize: 13, color: C.muted, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", textAlign: "center", marginBottom: 32 }}>Trusted Partnerships with World-Class Vendors</p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center" }}>
            {topPartners.map((p, i) => (
              <div key={p} style={{ background: i < 3 ? "rgba(0,98,204,0.12)" : "rgba(255,255,255,0.03)", border: `1px solid ${i < 3 ? "rgba(0,162,255,0.3)" : C.border}`, borderRadius: 8, padding: "10px 20px", fontSize: 13, fontWeight: i < 3 ? 700 : 500, color: i < 3 ? C.text : C.muted, transition: "all 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.color = C.text; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = i < 3 ? "rgba(0,162,255,0.3)" : C.border; e.currentTarget.style.color = i < 3 ? C.text : C.muted; }}
              >{p}</div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 28 }}>
            <Link to="/partners" style={{ color: C.blue, textDecoration: "none", fontSize: 14, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 6 }}>
              View All Partners <Icon name="arrow" size={14} color={C.blue}/>
            </Link>
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section style={{ padding: "80px 32px" }}>
        <div style={{ maxWidth: 1236, margin: "0 auto", background: `linear-gradient(135deg, rgba(0,98,204,0.2), rgba(0,162,255,0.08))`, border: `1px solid rgba(0,162,255,0.2)`, borderRadius: 20, padding: "60px 48px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 32, position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", right: -60, top: -60, width: 300, height: 300, borderRadius: "50%", background: "radial-gradient(circle, rgba(0,162,255,0.08) 0%, transparent 70%)", filter: "blur(40px)" }}/>
          <div>
            <h2 style={{ fontSize: "clamp(1.5rem, 2.5vw, 2rem)", fontWeight: 600, color: C.text, margin: "0 0 12px", fontFamily: "'Syne', 'Segoe UI', sans-serif" }}>Ready to Transform Your IT Infrastructure?</h2>
            <p style={{ color: C.muted, fontSize: 16, margin: 0 }}>Talk to our experts and get a tailored solution for your business.</p>
          </div>
          <Link to="/contact" style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", padding: "14px 36px", borderRadius: 8, fontSize: 15, fontWeight: 600, textDecoration: "none", boxShadow: "0 8px 32px rgba(0,98,204,0.4)", display: "inline-flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
            Get in Touch <Icon name="arrow" size={16} color="#fff"/>
          </Link>
        </div>
      </section>
    </div>
  );
}

function AboutPage() {
  const values = [
    { icon: "star", title: "Innovation", desc: "Continuously adopting cutting-edge technologies to deliver future-ready solutions." },
    { icon: "shield", title: "Trusted Advisors", desc: "Building long-term partnerships based on integrity, expertise, and reliability." },
    { icon: "users", title: "Expert Team", desc: "A highly qualified team of engineers and consultants with deep domain knowledge." },
    { icon: "globe", title: "Regional Reach", desc: "Operations across Lebanon and Syria with strategic vendor relationships globally." },
  ];
  return (
    <PageWrapper>
      <Section bg={C.bg0}>
        <SectionHeader tag="WHO WE ARE" title="Your Business Enabler"
          sub="Established in 2020, SAMware-cs is a leading IT consultancy and solutions provider." />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center" }} className="sw-about-grid">
          <div>
            <div style={{ borderRadius: 16, overflow: "hidden", marginBottom: 28, position: "relative", height: 220 }}>
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80" alt="Our Team"
                style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.75)" }}/>
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(2,9,19,0.8), transparent)" }}/>
              <div style={{ position: "absolute", bottom: 16, left: 20, color: "#fff", fontWeight: 700, fontSize: 16 }}>Our Expert Team</div>
            </div>
            <p style={{ color: C.muted, fontSize: 16.5, lineHeight: 1.85, marginBottom: 24 }}>
              SAMware-cs stands out for its extensive expertise and leadership in the regional IT landscape. We partner with world-class technology vendors to deliver comprehensive infrastructure, cloud, security, and network intelligence solutions tailored to each client's unique needs.
            </p>
            <p style={{ color: C.muted, fontSize: 16.5, lineHeight: 1.85, marginBottom: 32 }}>
              Our mission is simple: to be the bridge between technology and business value. As both a reseller and system integrator, we take ownership of every project from planning through deployment to ongoing support.
            </p>
            <blockquote style={{ borderLeft: `3px solid ${C.blue}`, paddingLeft: 20, margin: 0, color: C.text, fontStyle: "italic", fontSize: 16 }}>
              "We don't just sell technology — we build partnerships that drive transformation."
            </blockquote>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            {values.map(v => (
              <div key={v.title} style={{
                background: C.cardBg, border: `1px solid ${C.border}`,
                borderRadius: 12, padding: "24px 20px", transition: "all 0.3s ease",
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-4px)"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; }}
              >
                <div style={{ marginBottom: 12 }}><Icon name={v.icon} size={24}/></div>
                <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 8 }}>{v.title}</div>
                <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.6 }}>{v.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </Section>
      <style>{`@media(max-width:768px){.sw-about-grid{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}

function PartnersPage() {
  const topTier = [
    { name: "Dell Technologies", level: "Titanium Partner" },
    { name: "Oracle", level: "Platinum Partner" },
    { name: "VMware", level: "Premier Partner" },
  ];
  const partners = [
    "HPE","Cisco","Veeam","Nutanix","Red Hat","Fortinet","Palo Alto Networks",
    "NetApp","Veritas","Symantec","Juniper","Huawei","Lenovo","Aruba Networks",
    "F5 Networks","Check Point","Trend Micro","Sophos","SolarWinds","Splunk",
    "Citrix","Zerto","Commvault","Rubrik","Pure Storage","ExaGrid",
  ];
  return (
    <PageWrapper>
      <Section bg={C.bg1}>
        <SectionHeader tag="STRATEGIC PARTNERSHIPS" title="Powered by World-Class Vendors"
          sub="We maintain elite-level partnerships with over 30 global technology leaders." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 24, marginBottom: 48 }} className="sw-top-partners">
          {topTier.map(p => (
            <div key={p.name} style={{
              background: "linear-gradient(135deg, rgba(0,98,204,0.12), rgba(0,162,255,0.06))",
              border: `1px solid rgba(0,162,255,0.3)`, borderRadius: 14,
              padding: "28px 24px", textAlign: "center", position: "relative",
            }}>
              <div style={{ position: "absolute", top: 12, right: 12, background: "rgba(0,162,255,0.15)", borderRadius: 100, padding: "2px 10px", fontSize: 10, fontWeight: 700, color: C.blue }}>ELITE</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: C.text, marginBottom: 6 }}>{p.name}</div>
              <div style={{ fontSize: 13, color: C.blue, fontWeight: 600 }}>{p.level}</div>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
          {partners.map(p => (
            <div key={p} style={{
              background: "rgba(255,255,255,0.03)", border: `1px solid ${C.border}`,
              borderRadius: 8, padding: "8px 16px", fontSize: 13, color: C.muted, fontWeight: 500, transition: "all 0.2s",
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.color = C.text; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.muted; }}
            >{p}</div>
          ))}
        </div>
      </Section>
      <style>{`@media(max-width:700px){.sw-top-partners{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}

function SolutionsPage() {
  const cards = [
    { icon: "cpu", title: "Digital Transformation & Infrastructure", desc: "End-to-end data center modernization, compute, storage, and hyper-converged infrastructure.", points: ["Data Center Design & Build","Hyper-Converged Infrastructure","Compute & Storage","Virtualization"] },
    { icon: "cloud", title: "Public & Hybrid Cloud", desc: "Cloud strategy, migration, and managed services across public, private, and hybrid cloud environments.", points: ["Cloud Strategy & Assessment","Cloud Migration Services","Hybrid Cloud Integration","Cloud-Native Applications"] },
    { icon: "shield", title: "Enterprise Security", desc: "Comprehensive cybersecurity solutions protecting your infrastructure, data, and endpoints.", points: ["Network Security & Firewall","Endpoint Protection","Identity & Access Management","Security Operations"] },
    { icon: "network", title: "Active Network Intelligence", desc: "Intelligent networking solutions that optimize performance, visibility, and control.", points: ["SD-WAN & Software-Defined Networking","Network Monitoring & Analytics","Wireless & LAN Solutions","Network Automation"] },
  ];
  return (
    <PageWrapper>
      <Section bg={C.bg0}>
        <SectionHeader tag="SOLUTIONS" title="Comprehensive IT Solutions"
          sub="From infrastructure to cloud to security — we deliver integrated solutions that drive measurable business outcomes." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 24 }} className="sw-solutions-grid">
          {cards.map(c => (
            <div key={c.title} style={{
              background: C.cardBg, border: `1px solid ${C.border}`,
              borderRadius: 14, padding: "32px 28px", transition: "all 0.3s ease",
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = `0 20px 60px ${C.blueGlow}`; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
            >
              <div style={{ width: 52, height: 52, borderRadius: 12, background: "rgba(0,162,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                <Icon name={c.icon} size={26}/>
              </div>
              <h3 style={{ fontSize: 18, fontWeight: 600, color: C.text, margin: "0 0 12px" }}>{c.title}</h3>
              <p style={{ fontSize: 14.5, color: C.muted, lineHeight: 1.7, marginBottom: 20 }}>{c.desc}</p>
              {c.points.map(pt => (
                <div key={pt} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <div style={{ width: 18, height: 18, borderRadius: "50%", background: "rgba(0,162,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon name="check" size={10} color={C.blue}/>
                  </div>
                  <span style={{ fontSize: 13.5, color: C.muted }}>{pt}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Section>
      <style>{`@media(max-width:768px){.sw-solutions-grid{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}

function ServicesPage() {
  const methodology = ["Business Model Analysis","Requirements Gathering","Solution Design","Proof of Concept","Implementation","Quality Assurance","Support & Operate"];
  const offerings = [
    { icon: "server", label: "IT Consultancy" },{ icon: "cpu", label: "System Integration" },
    { icon: "cloud", label: "Cloud Services" },{ icon: "database", label: "Data Management" },
    { icon: "shield", label: "Cybersecurity" },{ icon: "network", label: "Network Solutions" },
    { icon: "cog", label: "Managed Services" },{ icon: "zap", label: "Digital Transformation" },
    { icon: "globe", label: "Business Continuity" },{ icon: "users", label: "Training & Enablement" },
    { icon: "clock", label: "24/7 Support" },{ icon: "star", label: "Project Management" },
  ];
  return (
    <PageWrapper>
      <Section bg={C.bg1}>
        <SectionHeader tag="SERVICES" title="Our Service Methodology"
          sub="A proven 7-step engagement model ensuring successful delivery and long-term client satisfaction." />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center", marginBottom: 72 }}>
          {methodology.map((step, i) => (
            <div key={step} style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, borderRadius: 10, padding: "12px 20px", display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 26, height: 26, borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800, color: "#fff" }}>{i+1}</div>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{step}</span>
              </div>
              {i < methodology.length - 1 && <Icon name="arrow" size={16} color="rgba(0,162,255,0.4)"/>}
            </div>
          ))}
        </div>
        <h3 style={{ fontSize: 22, fontWeight: 700, color: C.text, textAlign: "center", marginBottom: 32 }}>Service Offerings</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16 }} className="sw-offerings-grid">
          {offerings.map(o => (
            <div key={o.label} style={{
              background: C.cardBg, border: `1px solid ${C.border}`,
              borderRadius: 12, padding: "20px 16px",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 12, textAlign: "center",
              transition: "all 0.25s ease",
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-4px)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; }}
            >
              <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(0,162,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon name={o.icon} size={20}/>
              </div>
              <span style={{ fontSize: 13, fontWeight: 600, color: C.text }}>{o.label}</span>
            </div>
          ))}
        </div>
      </Section>
      <style>{`
        @media(max-width:900px){.sw-offerings-grid{grid-template-columns:repeat(3,1fr)!important}}
        @media(max-width:600px){.sw-offerings-grid{grid-template-columns:repeat(2,1fr)!important}}
      `}</style>
    </PageWrapper>
  );
}

function SupportPage() {
  const plans = [
    { name: "Standard", highlight: false, response: "Priority-Based", reviews: "When Needed", features: ["Business hours support","Ticket-based system","Remote assistance","Knowledge base access"] },
    { name: "Affiliate", highlight: false, response: "< 24 Hours", reviews: "Quarterly", features: ["Extended hours support","Dedicated account rep","Proactive monitoring","Quarterly business reviews"] },
    { name: "Elite", highlight: true, response: "< 4 Hours", reviews: "Quarterly", features: ["Priority escalation path","Named support engineers","Proactive health checks","Dedicated portal access","Quarterly reviews"] },
    { name: "Premier", highlight: false, response: "< 2 Hours", reviews: "Monthly", features: ["24/7 on-call support","Dedicated TAM","On-site support option","Monthly executive reviews","SLA guarantees","Custom reporting"] },
  ];
  return (
    <PageWrapper>
      <Section bg={C.bg0}>
        <SectionHeader tag="SUPPORT PACKAGES" title="Support Built for Your Business"
          sub="Choose the level of support that matches your operational needs." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 20 }} className="sw-support-grid">
          {plans.map(p => (
            <div key={p.name} style={{
              background: p.highlight ? `linear-gradient(160deg, rgba(0,98,204,0.22), rgba(0,162,255,0.1))` : C.cardBg,
              border: `${p.highlight ? 2 : 1}px solid ${p.highlight ? C.blue : C.border}`,
              borderRadius: 14, padding: "28px 22px", position: "relative",
              transition: "all 0.3s ease",
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = `0 20px 60px ${C.blueGlow}`; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
            >
              {p.highlight && <div style={{ position: "absolute", top: 14, right: 14, background: C.blue, borderRadius: 100, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fff" }}>MOST POPULAR</div>}
              <h3 style={{ fontSize: 20, fontWeight: 800, color: C.text, marginBottom: 20 }}>{p.name}</h3>
              <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 16, marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>Response Time</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: p.highlight ? C.blue : C.text }}>{p.response}</div>
              </div>
              <div style={{ borderBottom: `1px solid ${C.border}`, paddingBottom: 16, marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>Reviews</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: p.highlight ? C.blue : C.text }}>{p.reviews}</div>
              </div>
              {p.features.map(f => (
                <div key={f} style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 10 }}>
                  <div style={{ marginTop: 2 }}><Icon name="check" size={14} color={p.highlight ? C.blue : C.muted}/></div>
                  <span style={{ fontSize: 13, color: C.muted }}>{f}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Section>
      <style>{`
        @media(max-width:1024px){.sw-support-grid{grid-template-columns:repeat(2,1fr)!important}}
        @media(max-width:600px){.sw-support-grid{grid-template-columns:1fr!important}}
      `}</style>
    </PageWrapper>
  );
}

function ReferencesPage() {
  const [tab, setTab] = useState("Telecom");
  const sectors = {
    "Telecom": ["Syriatel","Wafa Telecom"],
    "Financial Services": ["National Islamic Bank","Shahba Bank","Ibdaa Bank","Real-State Bank","Syrian Commercial Bank","Bank Al-Sharq"],
    "Privat Companies": ["Pymera","United Insurance Co"],
    "Government & NGOs": ["ENG-reef","National Authority for IT Services","Ministry of Communications and Informations Technology"],
  };
  return (
    <PageWrapper>
      <Section bg={C.bg1}>
        <SectionHeader tag="REFERENCES" title="Trusted by Industry Leaders"
          sub="Over 10 clients across key sectors rely on SAMware-cs." />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginBottom: 40 }}>
          {Object.keys(sectors).map(t => (
            <button key={t} onClick={() => setTab(t)} style={{
              background: tab === t ? `linear-gradient(135deg, ${C.blueDark}, ${C.blue})` : "rgba(255,255,255,0.04)",
              border: `1px solid ${tab === t ? "transparent" : C.border}`,
              borderRadius: 8, padding: "8px 18px", fontSize: 13, fontWeight: 600,
              color: tab === t ? "#fff" : C.muted, cursor: "pointer", transition: "all 0.2s",
            }}>{t}</button>
          ))}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center" }}>
          {sectors[tab].map(c => (
            <div key={c} style={{
              background: C.cardBg, border: `1px solid ${C.border}`,
              borderRadius: 10, padding: "12px 20px", fontSize: 14, fontWeight: 500, color: C.text, transition: "all 0.2s",
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.color = C.blue; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.text; }}
            >{c}</div>
          ))}
        </div>
      </Section>
    </PageWrapper>
  );
}

function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [sent, setSent] = useState(false);
  const inputStyle = {
    width: "100%", background: "rgba(255,255,255,0.04)",
    border: `1px solid ${C.border}`, borderRadius: 8,
    padding: "12px 16px", color: C.text, fontSize: 14,
    outline: "none", boxSizing: "border-box", fontFamily: "inherit",
  };
  return (
    <PageWrapper>
      <Section bg={C.bg1}>
        <SectionHeader tag="CONTACT" title="Let's Start a Conversation"
          sub="Ready to transform your IT infrastructure? Our experts are here to help." />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60 }} className="sw-contact-grid">
          <div>
            {[
              { icon: "mail", label: "Email", val: "info@samware-cs.net" },
              { icon: "globe", label: "Website", val: "www.samware-cs.net" },
            ].map(i => (
              <div key={i.label} style={{ display: "flex", gap: 16, marginBottom: 24, alignItems: "flex-start" }}>
                <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(0,162,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name={i.icon} size={18}/>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: C.muted, fontWeight: 600, marginBottom: 4, textTransform: "uppercase" }}>{i.label}</div>
                  <div style={{ fontSize: 15, color: C.text }}>{i.val}</div>
                </div>
              </div>
            ))}
          </div>
          <div>
            {sent ? (
              <div style={{ background: "rgba(0,162,255,0.08)", border: `1px solid ${C.blue}`, borderRadius: 14, padding: "48px 32px", textAlign: "center" }}>
                <h3 style={{ fontSize: 22, fontWeight: 700, color: C.text, marginBottom: 12 }}>Message Sent! ✅</h3>
                <p style={{ color: C.muted }}>Our team will contact you within 24 hours.</p>
                <button onClick={() => { setSent(false); setForm({ name:"",email:"",company:"",message:"" }); }}
                  style={{ marginTop: 24, background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, border: "none", borderRadius: 8, padding: "12px 28px", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={e => { e.preventDefault(); if(form.name&&form.email&&form.message) setSent(true); }} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  <div>
                    <label style={{ display: "block", fontSize: 12, color: C.muted, fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Name *</label>
                    <input style={inputStyle} value={form.name} placeholder="John Smith" onChange={e => setForm({...form, name: e.target.value})} required/>
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 12, color: C.muted, fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Email *</label>
                    <input type="email" style={inputStyle} value={form.email} placeholder="john@company.com" onChange={e => setForm({...form, email: e.target.value})} required/>
                  </div>
                </div>
                <div>
                  <label style={{ display: "block", fontSize: 12, color: C.muted, fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Company</label>
                  <input style={inputStyle} value={form.company} placeholder="Your Company" onChange={e => setForm({...form, company: e.target.value})}/>
                </div>
                <div>
                  <label style={{ display: "block", fontSize: 12, color: C.muted, fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Message *</label>
                  <textarea rows={5} style={{...inputStyle, resize: "vertical"}} value={form.message} placeholder="Tell us about your IT needs..." onChange={e => setForm({...form, message: e.target.value})} required/>
                </div>
                <button type="submit" style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, border: "none", borderRadius: 8, padding: "14px 32px", color: "#fff", fontSize: 15, fontWeight: 600, cursor: "pointer" }}>
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </Section>
      <style>{`@media(max-width:768px){.sw-contact-grid{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}

function Footer() {
  return (
    <footer style={{ background: C.bg0, borderTop: `1px solid ${C.border}`, padding: "60px 32px 32px" }}>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 48, marginBottom: 48 }} className="sw-footer-grid">
          <div>
            <img src={LOGO} alt="SAMware-cs" style={{ height: 80, marginBottom: 20 }}/>
            <p style={{ color: C.muted, fontSize: 14, lineHeight: 1.8, maxWidth: 300 }}>
              Empowering organizations through technology since 2020.
            </p>
          </div>
          {[
            { heading: "Solutions", links: [["Solutions","/solutions"],["Services","/services"],["Support","/support"]] },
            { heading: "Company", links: [["About","/about"],["Partners","/partners"],["References","/references"],["Contact","/contact"]] },
          ].map(col => (
            <div key={col.heading}>
              <h4 style={{ fontSize: 13, fontWeight: 700, color: C.text, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 20 }}>{col.heading}</h4>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {col.links.map(([label, href]) => (
                  <Link key={label} to={href} style={{ color: C.muted, fontSize: 14, textDecoration: "none" }}
                    onMouseEnter={e => e.currentTarget.style.color = C.blue}
                    onMouseLeave={e => e.currentTarget.style.color = C.muted}
                  >{label}</Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 24, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <div style={{ fontSize: 13, color: C.muted }}>© {new Date().getFullYear()} SAMware-cs. All rights reserved.</div>
          <div style={{ fontSize: 13, color: C.muted }}>www.samware-cs.net</div>
        </div>
      </div>
      <style>{`
        @media(max-width:900px){.sw-footer-grid{grid-template-columns:1fr 1fr!important}}
        @media(max-width:600px){.sw-footer-grid{grid-template-columns:1fr!important}}
      `}</style>
    </footer>
  );
}

// ── Job Portal Page ────────────────────────────────────────────────────────
function JobsPage() {
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [cvFile, setCvFile] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const jobs = [
    {
      title: "PHP Developer",
      date: "January 14, 2026",
      type: "Full-time",
      featured: true,
      status: "active",
      desc: "We're seeking an experienced IT support person to join us on this journey, using their technology skills to make us even more efficient. In this role, the support person will oversee IT systems and assets, assist with upgrades and fixes, and provide training and support as needed. The ideal candidate will have extensive knowledge of...",
    },
    {
      title: "System Admin",
      date: "January 11, 2026",
      type: "Full-time",
      featured: true,
      status: "expired",
      desc: "Converged Systems represent the next evolution of IT. Composed of servers, storage, networking, and integrated software and services, the systems are designed to address the cost and complexity of data center operations and maintenance by pulling the IT components together into a single resource pool so they are easier to manage and faster to deploy.",
    },
    {
      title: "Sample Job",
      date: "January 11, 2026",
      type: "Full-time",
      featured: true,
      status: "expired",
      desc: "We're seeking an experienced IT support person to join us on this journey, using their technology skills to make us even more efficient. In this role, the support person will oversee IT systems and assets, assist with upgrades and fixes, and provide training and support as needed. The ideal candidate will have extensive knowledge of...",
    },
  ];

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.phone) return;
    setSubmitted(true);
  };

  // ── Job Detail Modal ──
  if (selected !== null) {
    const job = jobs[selected];
    return (
      <PageWrapper>
        <section style={{ background: C.bg0, padding: "80px 32px", minHeight: "80vh" }}>
          <div style={{ maxWidth: 760, margin: "0 auto" }}>
            <button onClick={() => { setSelected(null); setShowForm(false); setSubmitted(false); setCvFile(null); setFormData({ name: "", email: "", phone: "" }); }}
              style={{ background: "none", border: "none", cursor: "pointer", color: C.blue, fontSize: 14, fontWeight: 600, display: "flex", alignItems: "center", gap: 6, marginBottom: 32, padding: 0 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
              Back to Jobs
            </button>

            <div style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 16, padding: "36px 40px" }}>
              {/* Header */}
              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 16, marginBottom: 28 }}>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                    <h2 style={{ fontSize: 26, fontWeight: 800, color: C.text, margin: 0, fontFamily: "'Syne','Segoe UI',sans-serif" }}>{job.title}</h2>
                    {job.featured && <span style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 100 }}>Featured</span>}
                  </div>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                    <span style={{ fontSize: 13, color: C.muted, display: "flex", alignItems: "center", gap: 5 }}>
                      <Icon name="clock" size={13} color={C.muted}/> {job.date}
                    </span>
                    <span style={{ fontSize: 13, color: C.blue, fontWeight: 600, background: "rgba(0,162,255,0.1)", padding: "2px 10px", borderRadius: 100 }}>{job.type}</span>
                  </div>
                </div>
              </div>

              {/* Expired banner */}
              {job.status === "expired" && (
                <div style={{ background: "rgba(229,57,53,0.12)", border: "1.5px solid rgba(229,57,53,0.5)", borderRadius: 10, padding: "14px 20px", marginBottom: 28, display: "flex", alignItems: "center", gap: 12 }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#e53935" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  <span style={{ color: "#e53935", fontWeight: 700, fontSize: 16 }}>This job is Expired</span>
                </div>
              )}

              {/* Description */}
              <p style={{ fontSize: 15, color: C.muted, lineHeight: 1.85, marginBottom: 32 }}>{job.desc}</p>

              {/* Apply section - only for active jobs */}
              {job.status === "active" && !submitted && (
                <>
                  {!showForm ? (
                    <button onClick={() => setShowForm(true)} style={{
                      background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
                      border: "none", borderRadius: 8, padding: "13px 32px",
                      color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
                      boxShadow: "0 8px 24px rgba(0,98,204,0.35)",
                    }}>
                      Apply Now
                    </button>
                  ) : (
                    <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 28 }}>
                      <h3 style={{ fontSize: 18, fontWeight: 700, color: C.text, marginBottom: 24 }}>Submit Your Application</h3>
                      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                        {/* Name */}
                        <div>
                          <label style={{ fontSize: 13, fontWeight: 600, color: C.muted, display: "block", marginBottom: 7 }}>Full Name *</label>
                          <input value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})}
                            placeholder="Enter your full name"
                            style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: `1px solid ${C.border}`, borderRadius: 8, padding: "11px 16px", color: C.text, fontSize: 14, outline: "none", boxSizing: "border-box" }}
                            onFocus={e => e.target.style.borderColor = C.blue}
                            onBlur={e => e.target.style.borderColor = C.border}
                          />
                        </div>
                        {/* Email */}
                        <div>
                          <label style={{ fontSize: 13, fontWeight: 600, color: C.muted, display: "block", marginBottom: 7 }}>Email Address *</label>
                          <input value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})}
                            placeholder="Enter your email"
                            type="email"
                            style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: `1px solid ${C.border}`, borderRadius: 8, padding: "11px 16px", color: C.text, fontSize: 14, outline: "none", boxSizing: "border-box" }}
                            onFocus={e => e.target.style.borderColor = C.blue}
                            onBlur={e => e.target.style.borderColor = C.border}
                          />
                        </div>
                        {/* Phone */}
                        <div>
                          <label style={{ fontSize: 13, fontWeight: 600, color: C.muted, display: "block", marginBottom: 7 }}>Mobile Number *</label>
                          <input value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})}
                            placeholder="+961 XX XXX XXX"
                            type="tel"
                            style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: `1px solid ${C.border}`, borderRadius: 8, padding: "11px 16px", color: C.text, fontSize: 14, outline: "none", boxSizing: "border-box" }}
                            onFocus={e => e.target.style.borderColor = C.blue}
                            onBlur={e => e.target.style.borderColor = C.border}
                          />
                        </div>
                        {/* CV Upload */}
                        <div>
                          <label style={{ fontSize: 13, fontWeight: 600, color: C.muted, display: "block", marginBottom: 7 }}>Upload CV *</label>
                          <label style={{ display: "flex", alignItems: "center", gap: 12, background: "rgba(255,255,255,0.04)", border: `1.5px dashed ${cvFile ? C.blue : C.border}`, borderRadius: 8, padding: "16px 20px", cursor: "pointer", transition: "all 0.2s" }}
                            onMouseEnter={e => e.currentTarget.style.borderColor = C.blue}
                            onMouseLeave={e => e.currentTarget.style.borderColor = cvFile ? C.blue : C.border}
                          >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={cvFile ? C.blue : C.muted} strokeWidth="1.8"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                            <span style={{ fontSize: 14, color: cvFile ? C.text : C.muted }}>
                              {cvFile ? cvFile.name : "Click to upload your CV (PDF, DOC, DOCX)"}
                            </span>
                            <input type="file" accept=".pdf,.doc,.docx" style={{ display: "none" }}
                              onChange={e => setCvFile(e.target.files[0])}
                            />
                          </label>
                        </div>
                        {/* Buttons */}
                        <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                          <button onClick={handleSubmit} style={{
                            background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
                            border: "none", borderRadius: 8, padding: "12px 32px",
                            color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
                            boxShadow: "0 8px 24px rgba(0,98,204,0.3)",
                            opacity: (!formData.name || !formData.email || !formData.phone) ? 0.5 : 1,
                          }}>
                            Submit Application
                          </button>
                          <button onClick={() => setShowForm(false)} style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 8, padding: "12px 24px", color: C.muted, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Success message */}
              {submitted && (
                <div style={{ background: "rgba(5,150,105,0.12)", border: "1.5px solid rgba(5,150,105,0.4)", borderRadius: 10, padding: "20px 24px", display: "flex", alignItems: "center", gap: 14 }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
                  <div>
                    <div style={{ color: "#059669", fontWeight: 700, fontSize: 16 }}>Application Submitted!</div>
                    <div style={{ color: C.muted, fontSize: 13, marginTop: 4 }}>Thank you {formData.name}, we'll be in touch soon.</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </PageWrapper>
    );
  }

  // ── Job List ──
  return (
    <PageWrapper>
      <section style={{ background: C.bg0, padding: "80px 32px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
         <SectionHeader
           tag="CAREERS"
           title="Join Our Team"
           sub="We're always looking for talented people to help us grow. Explore our open positions below."
         />
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {jobs.map((job, i) => (
              <div key={i} style={{
                background: C.cardBg, border: `1px solid ${job.status === "expired" ? "rgba(229,57,53,0.2)" : C.border}`,
                borderRadius: 14, padding: "28px 32px", transition: "all 0.3s ease",
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = job.status === "expired" ? "rgba(229,57,53,0.5)" : C.blue; e.currentTarget.style.boxShadow = `0 8px 32px ${job.status === "expired" ? "rgba(229,57,53,0.1)" : C.blueGlow}`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = job.status === "expired" ? "rgba(229,57,53,0.2)" : C.border; e.currentTarget.style.boxShadow = "none"; }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 16 }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                      <h3 style={{ fontSize: 20, fontWeight: 700, color: C.text, margin: 0 }}>{job.title}</h3>
                      {job.featured && <span style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 100 }}>Featured</span>}
                      {job.status === "expired" && <span style={{ background: "rgba(229,57,53,0.15)", color: "#e53935", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 100, border: "1px solid rgba(229,57,53,0.3)" }}>Expired</span>}
                    </div>
                    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                      <span style={{ fontSize: 13, color: C.muted, display: "flex", alignItems: "center", gap: 5 }}>
                        <Icon name="clock" size={13} color={C.muted}/> {job.date}
                      </span>
                      <span style={{ fontSize: 13, color: C.blue, fontWeight: 600, background: "rgba(0,162,255,0.1)", padding: "2px 10px", borderRadius: 100 }}>{job.type}</span>
                    </div>
                  </div>
                </div>
                <p style={{ fontSize: 14.5, color: C.muted, lineHeight: 1.75, marginBottom: 20 }}>{job.desc}</p>
                <button onClick={() => setSelected(i)} style={{
                  background: job.status === "expired" ? "rgba(255,255,255,0.04)" : `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
                  border: job.status === "expired" ? `1px solid ${C.border}` : "none",
                  borderRadius: 8, padding: "10px 24px",
                  color: job.status === "expired" ? C.muted : "#fff",
                  fontSize: 14, fontWeight: 600, cursor: "pointer",
                  display: "inline-flex", alignItems: "center", gap: 8,
                }}>
                  View Details <Icon name="arrow" size={14} color={job.status === "expired" ? C.muted : "#fff"}/>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}

// ── Products Page ─────────────────────────────────────────────────────────────
function ServersPage() {
  const vendors = [
    { name: "Dell Technologies", emoji: "🖥️", desc: "Industry-leading PowerEdge rack, tower, and blade servers for enterprise workloads.", url: "https://www.dell.com/en-us/shop/servers-storage-and-networking/sc/servers", color: "#007DB8" },
    { name: "HPE", emoji: "🟢", desc: "ProLiant and Synergy servers for hybrid cloud environments.", url: "https://www.hpe.com/us/en/servers.html", color: "#01A982" },
    { name: "Lenovo", emoji: "🔴", desc: "ThinkSystem servers built for reliability and high-performance computing.", url: "https://www.lenovo.com/us/en/servers-storage/", color: "#E2231A" },
    { name: "Huawei", emoji: "🌐", desc: "FusionServer Pro series for intelligent, high-density data centers.", url: "https://e.huawei.com/en/products/servers", color: "#CF0A2C" },
  ];
  return (
    <PageWrapper>
      <section style={{ background: C.bg0, padding: "80px 32px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionHeader tag="SERVERS" title="Enterprise Server Solutions" sub="We partner with the world's leading server vendors to deliver reliable, high-performance infrastructure." />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 24 }} className="sw-vendors-grid">
            {vendors.map(v => (
              <div key={v.name} style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 16, padding: "36px 32px", transition: "all 0.3s ease", display: "flex", flexDirection: "column", gap: 16 }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = `0 20px 60px ${C.blueGlow}`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ width: 56, height: 56, borderRadius: 14, background: `${v.color}22`, border: `1px solid ${v.color}44`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>{v.emoji}</div>
                  <div>
                    <h3 style={{ fontSize: 20, fontWeight: 700, color: C.text, margin: 0 }}>{v.name}</h3>
                    <span style={{ fontSize: 12, color: C.blue, fontWeight: 600 }}>Enterprise Servers</span>
                  </div>
                </div>
                <p style={{ fontSize: 14.5, color: C.muted, lineHeight: 1.75, margin: 0 }}>{v.desc}</p>
                <a href={v.url} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", textDecoration: "none", padding: "10px 24px", borderRadius: 8, fontSize: 14, fontWeight: 600, alignSelf: "flex-start" }}
                  onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                  onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
                  View {v.name} Servers <Icon name="arrow" size={14} color="#fff" />
                </a>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 48 }}>
            <Link to="/contact" style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", padding: "14px 36px", borderRadius: 8, fontSize: 15, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
              Request a Quote <Icon name="arrow" size={16} color="#fff" />
            </Link>
          </div>
        </div>
      </section>
      <style>{`@media(max-width:768px){.sw-vendors-grid{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}

function NetworkingPage() {
  const vendors = [
    { name: "Cisco", emoji: "🔵", desc: "Industry-standard switches, routers, and wireless networking solutions.", url: "https://www.cisco.com/c/en/us/products/switches/index.html", color: "#1BA0D7" },
    { name: "Huawei", emoji: "🌐", desc: "CloudEngine switches and AR routers for intelligent enterprise networking.", url: "https://e.huawei.com/en/products/network-switches", color: "#CF0A2C" },
    { name: "Fortinet", emoji: "🛡️", desc: "FortiGate next-generation firewalls and secure networking for enterprise.", url: "https://www.fortinet.com/products/next-generation-firewall", color: "#EE3124" },
    { name: "Juniper Networks", emoji: "🍃", desc: "AI-driven networking with EX switches and SRX firewalls.", url: "https://www.juniper.net/us/en/products/switches.html", color: "#84BD00" },
    { name: "F5 Networks", emoji: "⚡", desc: "Application delivery and security with load balancers and WAF solutions.", url: "https://www.f5.com/products", color: "#E4002B" },
  ];
  return (
    <PageWrapper>
      <section style={{ background: C.bg0, padding: "80px 32px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionHeader tag="NETWORKING" title="Networking Solutions" sub="Enterprise-grade networking equipment from the world's most trusted vendors." />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 24 }} className="sw-vendors-grid">
            {vendors.map(v => (
              <div key={v.name} style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 16, padding: "36px 32px", transition: "all 0.3s ease", display: "flex", flexDirection: "column", gap: 16 }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = `0 20px 60px ${C.blueGlow}`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ width: 56, height: 56, borderRadius: 14, background: `${v.color}22`, border: `1px solid ${v.color}44`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>{v.emoji}</div>
                  <div>
                    <h3 style={{ fontSize: 20, fontWeight: 700, color: C.text, margin: 0 }}>{v.name}</h3>
                    <span style={{ fontSize: 12, color: C.blue, fontWeight: 600 }}>Networking Equipment</span>
                  </div>
                </div>
                <p style={{ fontSize: 14.5, color: C.muted, lineHeight: 1.75, margin: 0 }}>{v.desc}</p>
                <a href={v.url} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", textDecoration: "none", padding: "10px 24px", borderRadius: 8, fontSize: 14, fontWeight: 600, alignSelf: "flex-start" }}
                  onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                  onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
                  View {v.name} Products <Icon name="arrow" size={14} color="#fff" />
                </a>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 48 }}>
            <Link to="/contact" style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", padding: "14px 36px", borderRadius: 8, fontSize: 15, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
              Request a Quote <Icon name="arrow" size={16} color="#fff" />
            </Link>
          </div>
        </div>
      </section>
      <style>{`@media(max-width:768px){.sw-vendors-grid{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}

function PCsPage() {
  const vendors = [
    { name: "Dell Technologies", emoji: "🖥️", desc: "OptiPlex desktops and Precision workstations for business productivity.", url: "https://www.dell.com/en-us/shop/dell-desktops/sc/desktops", color: "#007DB8" },
    { name: "HPE", emoji: "🟢", desc: "HP EliteDesk and Z Workstation series for enterprise performance.", url: "https://www.hpe.com/us/en/desktops-workstations.html", color: "#01A982" },
    { name: "Lenovo", emoji: "🔴", desc: "ThinkCentre desktops and ThinkStation workstations for demanding applications.", url: "https://www.lenovo.com/us/en/desktops/", color: "#E2231A" },
    { name: "Huawei", emoji: "🌐", desc: "MateStation and WorkSpace all-in-one PCs for modern enterprise.", url: "https://consumer.huawei.com/en/desktops/", color: "#CF0A2C" },
    { name: "ASUS", emoji: "💻", desc: "ExpertCenter and ProArt workstations for professionals.", url: "https://www.asus.com/us/commercial/workstations/", color: "#00539B" },
  ];
  return (
    <PageWrapper>
      <section style={{ background: C.bg0, padding: "80px 32px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionHeader tag="PCs & WORKSTATIONS" title="Business PCs & Workstations" sub="Professional computing solutions from leading vendors for every business need." />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 24 }} className="sw-vendors-grid">
            {vendors.map(v => (
              <div key={v.name} style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 16, padding: "36px 32px", transition: "all 0.3s ease", display: "flex", flexDirection: "column", gap: 16 }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = `0 20px 60px ${C.blueGlow}`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ width: 56, height: 56, borderRadius: 14, background: `${v.color}22`, border: `1px solid ${v.color}44`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>{v.emoji}</div>
                  <div>
                    <h3 style={{ fontSize: 20, fontWeight: 700, color: C.text, margin: 0 }}>{v.name}</h3>
                    <span style={{ fontSize: 12, color: C.blue, fontWeight: 600 }}>PCs & Workstations</span>
                  </div>
                </div>
                <p style={{ fontSize: 14.5, color: C.muted, lineHeight: 1.75, margin: 0 }}>{v.desc}</p>
                <a href={v.url} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", textDecoration: "none", padding: "10px 24px", borderRadius: 8, fontSize: 14, fontWeight: 600, alignSelf: "flex-start" }}
                  onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                  onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
                  View {v.name} PCs <Icon name="arrow" size={14} color="#fff" />
                </a>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 48 }}>
            <Link to="/contact" style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", padding: "14px 36px", borderRadius: 8, fontSize: 15, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
              Request a Quote <Icon name="arrow" size={16} color="#fff" />
            </Link>
          </div>
        </div>
      </section>
      <style>{`@media(max-width:768px){.sw-vendors-grid{grid-template-columns:1fr!important}}`}</style>
    </PageWrapper>
  );
}


export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: C.bg0, color: C.text, minHeight: "100vh" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap');
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
          html { scroll-behavior: smooth; }
          ::-webkit-scrollbar { width: 6px; }
          ::-webkit-scrollbar-track { background: #020913; }
          ::-webkit-scrollbar-thumb { background: rgba(0,162,255,0.3); border-radius: 3px; }
          input::placeholder, textarea::placeholder { color: rgba(122,154,181,0.5); }
        `}</style>
        <Navbar/>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/about" element={<AboutPage/>}/>
          <Route path="/partners" element={<PartnersPage/>}/>
          <Route path="/solutions" element={<SolutionsPage/>}/>
          <Route path="/services" element={<ServicesPage/>}/>
          <Route path="/support" element={<SupportPage/>}/>
          <Route path="/references" element={<ReferencesPage/>}/>
          <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/jobs" element={<JobsPage/>}/>
        <Route path="/dashboard/jobs" element={<JobsDashboard/>}/>
        <Route path="/products/servers" element={<ServersPage/>}/>
        <Route path="/products/networking" element={<NetworkingPage/>}/>
        <Route path="/products/pcs" element={<PCsPage/>}/>
        </Routes>
        <Footer/>
      </div>
    </BrowserRouter>
  );
}
